import styled from 'styled-components';

export const Container = styled.button`
  background: ${({ theme }) => theme.colors.BTNBG};
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 0.8rem;
  padding: 1.5rem 2rem;
  font-size: 1.4rem;
  transition: all 0.5s ease;
  color: ${({ theme }) => theme.colors.BTNLABEL};
  cursor: pointer;
  font-weight: 700;

  @media (max-width: 1024px) {
    font-size: 1rem;
    padding: 1rem;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.BTNBGH};
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.BTNLABELH};
  }
`;
